<template>
    <b-row :class="content.class_color " align-h="start" class="pb-5">
        <b-col cols="12"  md="5" lg="5" class="marck-center-vertical justify-content-center">
            <p :class="content.class_titulo" v-html="content.titulo"></p>
        </b-col>
        <b-col lg="7"  md="7" cols="12" class="marck-center-vertical">
            <section-carrusel :settings="settings" :content="content.socios"/>
        </b-col>
    </b-row>
</template>
<script>
    import SectionCarrusel from '@/components/userInternal/section-carrusel'

    export default {
        name: 'section-associate',
        components: {SectionCarrusel},
        props: {
            content: Object
        },
        data: () => ({
            settings: {
                "infinite": false,
                "slidesToShow": 3,
                "rows": 1,
                "slidesPerRow": 1,
                "arrows": false,
                "slidesToScroll": 3,
                "autoplay": true,
                "speed": 4000,
                "autoplaySpeed": 4000,
                "cssEase": "linear",
                "rtl": true,
                "swipeToSlide": true,
                "touchMove": true,
                "initialSlide": 0,
                "responsive": [
                    {
                        "breakpoint": 1024,
                        "settings": {
                            "slidesToShow": 3,
                            "slidesToScroll": 3,
                        }
                    },
                    {
                        "breakpoint": 600,
                        "settings": {
                            "slidesToShow": 2,
                            "slidesToScroll": 2,
                            "initialSlide": 2
                        }
                    },
                    {
                        "breakpoint": 480,
                        "settings": {
                            "slidesToShow": 4,
                            "slidesToScroll": 4
                        }
                    }
                ]
            }
        }),
        created: function () {
            var self = this;
            setInterval(function() {
                self.settings.rtl = !self.settings.rtl
            }, 15000);
        },
    }
</script>
<style scoped>

@media (max-width: 600px) {
    .marck-center-vertical{
        font-size: 10px;
        justify-content: left !important;
    }

    .mark-titulo{
        font-size: 30px;
        padding-top: 2px;
    }
}


</style>

